import { z } from 'zod';

export const avatarAcceptedMimeTypes = ['image/jpeg', 'image/png', 'image/webp'] as const;
export const AVATAR_MAX_UPLOAD_BYTES = 5 * 1024 * 1024;
export const AVATAR_CANONICAL_SIZE = 512;
export const AVATAR_CANONICAL_CONTENT_TYPE = 'image/webp';

export const avatarMimeTypeSchema = z.enum(avatarAcceptedMimeTypes, {
  error: 'Le format d image n est pas supporté.',
});

export const avatarPrepareUploadSchema = z.object({
  contentType: avatarMimeTypeSchema,
  filename: z.string().trim().min(1, {
    error: 'Le nom de fichier est requis.',
  }).max(255, {
    error: 'Le nom de fichier est trop long.',
  }),
});

export const avatarFinalizeUploadSchema = z.object({
  temporaryObjectKey: z.string().trim().min(1, {
    error: 'La clé objet temporaire est requise.',
  }).max(1024, {
    error: 'La clé objet temporaire est invalide.',
  }),
});

export const avatarPrepareUploadResponseSchema = z.object({
  headers: z.object({
    'Content-Type': avatarMimeTypeSchema,
  }),
  maxUploadBytes: z.number().int().positive(),
  method: z.literal('PUT'),
  temporaryObjectKey: z.string().min(1),
  uploadUrl: z.url(),
});

export const avatarFinalizeUploadResponseSchema = z.object({
  imageUrl: z.url({
    error: 'L URL publique de l avatar est invalide.',
  }),
  objectKey: z.string().min(1),
});

export type AvatarPrepareUploadDTO = z.infer<typeof avatarPrepareUploadSchema>;
export type AvatarFinalizeUploadDTO = z.infer<typeof avatarFinalizeUploadSchema>;
export type AvatarPrepareUploadResponseDTO = z.infer<typeof avatarPrepareUploadResponseSchema>;
export type AvatarFinalizeUploadResponseDTO = z.infer<typeof avatarFinalizeUploadResponseSchema>;
